module.exports = __webpack_public_path__ + "img/grenada-3.169c9ae3.png";